import styled from 'styled-components';
import Image from '@/components/Image';
import { FC } from 'react';
import TextColumn, { TextColumnHeading, TextColumnProps } from '@/components/_atoms/text-columns/TextColumn';

interface TextColumnWithImageProps extends TextColumnProps {
  imageSrc: string;
  title: string;
}

const TextColumnWithImage: FC<TextColumnWithImageProps> = ({ imageSrc, title, children }) => {
  return (
    <TextColumn>
      <ColumnImage>
        <Image src={imageSrc} alt={title} fill />
      </ColumnImage>

      <TextColumnHeading>{title}</TextColumnHeading>

      {children}
    </TextColumn>
  );
};

export default TextColumnWithImage;

const ColumnImage = styled.div`
  position: relative;

  width: var(--image-size);
  height: var(--image-size);

  align-self: var(--text-columns-flex-alignment);

  img {
    object-fit: contain;
    object-position: var(--text-columns-text-alignment, left) center;
  }
`;
